import { HttpData, HttpNoData } from '../../../../Core';

export async function getBudgets(jwt) {
    const response = await HttpNoData('/api/v1/budgets', 'GET', jwt);
    return response.data;
}

export async function createBudget(name, jwt) {
    const response = await HttpData('/api/v1/budgets', 'POST', jwt, { name });
    return response.data;
}

export async function updateBudget(id, name, jwt) {
    const response = await HttpData(`/api/v1/budgets/${id}`, 'PUT', jwt, { name });
    return response.data;
}

export async function deleteBudget(id, jwt) {
    const response = await HttpNoData(`/api/v1/budgets/${id}`, 'DELETE', jwt);
    return response.statusSuccessful;
}